import { ProgressLoadingBar } from '@ohif/ui-next';

export default {
  'ui.progressLoadingBar': ProgressLoadingBar,
};
